
import { useState } from 'react';

export default function Footer() {
  const [logoError, setLogoError] = useState(false);

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            {logoError ? (
              <div className="text-2xl font-bold text-blue-400 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                AffittoOnline.it
              </div>
            ) : (
              <img
                src="/logo_3.png"
                alt="affittonline.it — Contratti con Pieno Valore Legale"
                className="h-10 md:h-12 w-auto mb-4"
                loading="lazy"
                onError={() => setLogoError(true)}
              />
            )}
            <p className="text-gray-300 mb-4">
              Servizio professionale per la creazione di contratti di locazione in videoconferenza. 
              Semplice, veloce e con pieno valore legale.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                <i className="ri-mail-fill text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Servizi</h3>
            <ul className="space-y-2">
              <li><a href="/consulenza" className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer">Consulenza Gratuita</a></li>
              <li><a href="/contratto" className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer">Contratti di Locazione</a></li>
              <li><a href="/firma" className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer">Firma Digitale</a></li>
              <li><a href="/registrazione" className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer">Registrazione AdE</a></li>
              <li><a href="/polizza-morosita" className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer">Polizza Assicurativa</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contatti</h3>
            <ul className="space-y-2">
              <li className="text-gray-300">
                <i className="ri-phone-fill mr-2"></i>
                <a href="tel:+393470088959" className="hover:text-blue-400 transition-colors cursor-pointer">+39 3470088959</a>
              </li>
              <li className="text-gray-300">
                <i className="ri-mail-fill mr-2"></i>
                <a href="mailto:info@affittonline.it" className="hover:text-blue-400 transition-colors cursor-pointer">info@affittonline.it</a>
              </li>
              <li className="text-gray-300">
                <i className="ri-time-fill mr-2"></i>
                Lun-Ven 8:00-20:00
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 AffittoOnline.it. Tutti i diritti riservati.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="/privacy" className="text-gray-400 hover:text-blue-400 text-sm transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="/termini" className="text-gray-400 hover:text-blue-400 text-sm transition-colors cursor-pointer">
              Termini di Servizio
            </a>
            
          </div>
        </div>
      </div>
    </footer>
  );
}
